// AutoMapper
import { AutoMap } from '@nartc/automapper';

export class TravelDto {
    @AutoMap() purpose: number;
    @AutoMap() type: number;
    @AutoMap() carrier: string;
    @AutoMap() tourOperator: string;
    @AutoMap() group: string;
    @AutoMap() adultsNumber: number;
    @AutoMap() childrenNumber: number;
    @AutoMap() from: string;
    @AutoMap() to: string;
    @AutoMap() startDate: string;
    @AutoMap() goingFlightNumber: string;
    @AutoMap() isReturnBooked: boolean;
    @AutoMap() returnDate: string;
    @AutoMap() returnFlightNumber: string;
    @AutoMap() bookingNumber: string;
    @AutoMap() isTicketChangeable: boolean;
    @AutoMap() bookingAgency: string;
    @AutoMap() bookingAgencyPhoneNumber: string;
}